import { createMigrate } from "redux-persist";

const draftOrdersReportDefault = {
  UserSearch: "",
  SelectDateType: "created_at",
  is_bundle_orders: false,
  FromDate: "",
  ToDate: "",
  SelectOrderType: "DRAFT,RENEW",
  SelectRegion: "",
  OrderSource: "",
  WarehouseName: "",
  ProductName: "",
  UserLimit: 10,
  CurrentPage: 1,
};

// old "all orders" status strings, before DRAFT was included
const afsAllOrdersLegacyStatuses = [
  "OPEN,INVOICE_PENDING,DISPATCH_PENDING,DISPATCHED,DELIVERED,CANCELLED,RETURN",
  "OPEN,INVOICE_PENDING,DISPATCH_PENDING,DISPATCHED,DELIVERED,CANCELLED,RETURN,SO_HALF_APPROVAL",
];

const afsAllOrdersStatus =
  "OPEN,INVOICE_PENDING,DISPATCH_PENDING,DISPATCHED,DELIVERED,CANCELLED,RETURN,SO_HALF_APPROVAL,DRAFT";

const migrations = {
  1: (state) => {
    if (!state) return state;

    return {
      ...state,
      adminReducers: {
        ...state.adminReducers,
        OrderManagmentFilter: {
          ...state.adminReducers?.OrderManagmentFilter,
          DraftOrdersReport:
            state.adminReducers?.OrderManagmentFilter?.DraftOrdersReport ??
            draftOrdersReportDefault,
        },
      },
    };
  },
  2: (state) => {
    if (!state) return state;

    const allAfsOrders =
      state.adminReducers?.AFSOrderManagmentFilter?.all_afs_orders;
    const storedStatus = allAfsOrders?.Status;

    // only refresh the status when the user is still on the "All Orders"
    // selection - an explicitly chosen filter is left untouched
    const shouldUpdateStatus =
      storedStatus === undefined ||
      afsAllOrdersLegacyStatuses.includes(storedStatus);

    return {
      ...state,
      adminReducers: {
        ...state.adminReducers,
        AFSOrderManagmentFilter: {
          ...state.adminReducers?.AFSOrderManagmentFilter,
          all_afs_orders: {
            ...allAfsOrders,
            Status: shouldUpdateStatus ? afsAllOrdersStatus : storedStatus,
          },
        },
      },
    };
  },
};

export const migrate = createMigrate(migrations, { debug: false });
